import { render } from "./AboutPopup.vue?vue&type=template&id=1153fbc3&scoped=true&ts=true"
import script from "./AboutPopup.vue?vue&type=script&lang=ts"
export * from "./AboutPopup.vue?vue&type=script&lang=ts"

import "./AboutPopup.vue?vue&type=style&index=0&id=1153fbc3&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1153fbc3"]])

export default __exports__